// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-1 {
  padding: 0;
  margin-right: 1.25rem;
}

.col-11 {
  padding: 0;
  margin: 0.25rem;
}

.disabled-dropdown {
  pointer-events: none;
}

.dropdown--font {
  color: var(--text-color) !important;
}

::ng-deep .p-fluid {
  display: flex !important;
}

.selected-placeholder .p-dropdown .p-dropdown-label.p-placeholder {
  color: var(--text-color);
}

.align-middle {
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: 10px;
}

.disabled-like {
  pointer-events: none;
  opacity: 0.6;
}
.disabled-like.ng-reflect-placeholder {
  color: lightgray !important;
}
.disabled-like.selected-placeholder .p-dropdown .p-dropdown-label.p-placeholder {
  color: lightgray !important;
}

.inputDropdown .p-dropdown-label.p-inputtext {
  padding: 0rem;
}

.inputDropdown .p-dropdown .p-dropdown-label.p-inputtext {
  margin-left: 0.5rem;
}

.margin-p {
  margin-top: 3.5em;
}

.custom-tooltip {
  max-width: 400px;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/measure/question/question-instance/question-instance.component.scss"],"names":[],"mappings":"AAMA;EACI,UAAA;EACA,qBAAA;AALJ;;AAQA;EACI,UAAA;EACA,eAAA;AALJ;;AAQA;EACI,oBAAA;AALJ;;AASA;EACI,mCAAA;AANJ;;AASA;EACI,wBAAA;AANJ;;AASA;EACI,wBAAA;AANJ;;AASA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AANJ;;AAWA;EACI,oBAAA;EACA,YAAA;AARJ;AAUI;EACI,2BAAA;AARR;AAaY;EACI,2BAAA;AAXhB;;AAqCA;EACI,aAAA;AAlCJ;;AAqCA;EACI,mBAAA;AAlCJ;;AAqCA;EACI,iBAAA;AAlCJ;;AAqCA;EACI,gBAAA;EACA,aAAA;AAlCJ","sourcesContent":["// .navIcons {\n//     .material-symbols-outlined {\n//         font-size: 20px;\n//     }\n// }\n\n.col-1 {\n    padding: 0;\n    margin-right: 1.25rem;\n}\n\n.col-11 {\n    padding: 0;\n    margin: .25rem;\n}\n\n.disabled-dropdown {\n    pointer-events: none;\n}\n\n\n.dropdown--font {\n    color: var(--text-color) !important;\n}\n\n::ng-deep .p-fluid {\n    display: flex !important\n}\n\n.selected-placeholder .p-dropdown .p-dropdown-label.p-placeholder {\n    color: var(--text-color);\n}\n\n.align-middle {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    margin-left: 10px;\n}\n\n\n\n.disabled-like {\n    pointer-events: none;\n    opacity: 0.6;\n\n    &.ng-reflect-placeholder {\n        color: lightgray !important;\n    }\n\n    &.selected-placeholder {\n        .p-dropdown {\n            .p-dropdown-label.p-placeholder {\n                color: lightgray !important;\n            }\n        }\n    }\n}\n\n// .hide-dropdown-icon .p-dropdown .p-dropdown-trigger {\n//     display: none !important;\n// }\n\n// .lightgray {\n//     color: lightgray;\n// }\n\n// .p-placeholder,\n// input::placeholder {\n//     font-style: italic !important;\n//     font-weight: lighter !important;\n//     opacity: 0.8;\n// }\n\n// input {\n//     color: var(--text-color);\n//     font-weight: 600 !important;\n// }\n\n.inputDropdown .p-dropdown-label.p-inputtext {\n    padding: 0rem;\n}\n\n.inputDropdown .p-dropdown .p-dropdown-label.p-inputtext {\n    margin-left: 0.5rem;\n}\n\n.margin-p {\n    margin-top: 3.5em;\n}\n\n.custom-tooltip {\n    max-width: 400px;\n    padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
